module.exports = __webpack_public_path__ + "static/stunners-6402c315c60fbc04a6aaf817ef1f7f12.png";